export enum PluviometriaObservadaCoresInterpolada {
	VALOR_MINIMO = '#F93537',
	VALOR_EXTREMAMENTE_BAIXO = '#FE5F35',
	VALOR_MUITO_BAIXO = '#FCA973',
	VALOR_BAIXO = '#FACC9B',
	VALOR_MEDIO_BAIXO = '#FDFD99',
	VALOR_MEDIO = '#9AFD02',
	VALOR_MEDIO_ALTO = '#73D973',
	VALOR_ALTO = '#32CD31',
	VALOR_MUITO_ALTO = '#009B36',
	VALOR_EXTREMAMENTE_ALTO = '#0097FE',
	VALOR_QUASE_MAXIMO = '#007FFF',
	VALOR_MAXIMO = '#0065FF',
}
export enum PluviometriaObservadaCores {
	VALOR_ATE_ZERO = '#E81F22',
	VALOR_MINIMO = '#F93537',
	VALOR_EXTREMAMENTE_BAIXO = '#FE5F35',
	VALOR_MUITO_BAIXO = '#FCA973',
	VALOR_BAIXO = '#FACC9B',
	VALOR_MEDIO_BAIXO = '#FDFD99',
	VALOR_MEDIO = '#9AFD02',
	VALOR_MEDIO_ALTO = '#73D973',
	VALOR_ALTO = '#32CD31',
	VALOR_MUITO_ALTO = '#009B36',
	VALOR_EXTREMAMENTE_ALTO = '#0097FE',
	VALOR_QUASE_MAXIMO = '#007FFF',
	VALOR_MAXIMO = '#0065FF',
}

export enum BalancoHidricoDefCores {
	VALOR_MINIMO = '#F93537',
	VALOR_EXTREMAMENTE_BAIXO = '#FE5F35',
	VALOR_MUITO_BAIXO = '#FCA973',
	VALOR_BAIXO = '#FACC9B',
	VALOR_MEDIO = '#9AFD02',
	VALOR_ALTO = '#32CD31',
	VALOR_MUITO_ALTO = '#009B36',
	VALOR_EXTREMAMENTE_ALTO = '#0097FE',
	VALOR_QUASE_MAXIMO = '#007FFF',
	VALOR_MAXIMO = '#0065FF',
}

export enum BalancoHidricoArmCores {
	VALOR_MINIMO = '#F93537',
	VALOR_MUITO_BAIXO = '#FCA973',
	VALOR_MEDIO = '#9AFD02',
	VALOR_MUITO_ALTO = '#009B36',
	VALOR_EXTREMAMENTE_ALTO = '#0097FE',
	VALOR_MAXIMO = '#0065FF',
}

export enum TemperaturaCores {
	VALOR_MINIMO = '#99004D',
	VALOR_EXTREMAMENTE_BAIXO = '#0000FF',
	VALOR_MUITO_BAIXO = '#0080FF',
	VALOR_BAIXO = '#00FFFF',
	VALOR_MEDIO_BAIXO = '#00FF80',
	VALOR_MEDIO = '#80FF00',
	VALOR_MEDIO_ALTO = '#FFFF00',
	VALOR_ALTO = '#E1D176',
	VALOR_MUITO_ALTO = '#FFA95A',
	VALOR_EXTREMAMENTE_ALTO = '#FF763D',
	VALOR_MAXIMO = '#FF0000',
}

export enum DesvioMilimetroCores {
	VALOR_MINIMO = '#fd1a13', // -300
	VALOR_EXTREMAMENTE_BAIXO = '#FE6442', // -200
	VALOR_MUITO_BAIXO = '#FE7E10', // -150
	VALOR_BAIXO = '#FFC72A', // -100
	VALOR_MEDIO_BAIXO = '#FFFC9D', //  -50
	VALOR_NEUTRO = '#cbcdfd', //    0
	VALOR_MEDIO_ALTO = '#959efb', //   50
	VALOR_ALTO = '#6073fe', //  100
	VALOR_MUITO_ALTO = '#003a96', //  150
	VALOR_MAXIMO = '#310f65', //  200
}

export enum DesvioPorcentagemCores {
	VALOR_MINIMO = '#fd1a13', // -100
	VALOR_MUITO_BAIXO = '#FE7E10', // -75
	VALOR_BAIXO = '#FFC72A', // -50
	VALOR_MEDIO_BAIXO = '#FFFC9D', // -25
	VALOR_NEUTRO = '#cbcdfd', // 0
	VALOR_MEDIO_ALTO = '#959efb', // 25
	VALOR_ALTO = '#6073fe', // 50
	VALOR_MUITO_ALTO = '#003a96', // 75
	VALOR_EXTREMAMENTE_ALTO = '#310f65', // 100
	VALOR_MAXIMO = '#7030A0', // 125
}

export enum NDCCores {
	VALOR_MINIMO = '#F93537',
	VALOR_QUASE_MINIMO = '#FE5F35',
	VALOR_EXTREMAMENTE_BAIXO = '#FCA973',
	VALOR_MUITO_BAIXO = '#FACC9B',
	VALOR_BAIXO = '#FDFD99',
	VALOR_MEDIO_BAIXO = '#9AFD02',
	VALOR_MEDIO = '#73D973',
	VALOR_MEDIO_ALTO = '#32CD31',
	VALOR_ALTO = '#1EAA33',
	VALOR_MUITO_ALTO = '#008A25',
	VALOR_EXTREMAMENTE_ALTO = '#0097FE',
	VALOR_QUASE_MAXIMO = '#007FFF',
	VALOR_MAXIMO = '#0065FF',
}

export enum ZoneamentoedafoclimaticoCores {
	INAPTO = '#FFDE9A',
	APTO = '#60D954',
}
